<template>
	<div class="cloth-checkbox" :class="{ 'checked': selections.indexOf(cloth) !== -1 }">
		<span class="serif program-number cloth-{{ cloth }}">{{ cloth }}</span>
		<input type="checkbox" v-model="selections" :value="cloth" />
		<span class="right empty"></span>
		<span class="right checked">
			<img v-icon.literal="checkmark.svg" alt="Checkmark" />
		</span>
	</div>
</template>

<script>
	export default {
		props: [ 'selections', 'cloth' ]
	}
</script>



/** WEBPACK FOOTER **
 ** ClothCheckbox.vue?1bc46e97
 **/